import { render, staticRenderFns, recyclableRender, components } from "./vk-data-input-editor.vue?vue&type=template&id=66a21f64&scoped=true&"
var renderjs
import script from "./vk-data-input-editor.vue?vue&type=script&lang=js&"
export * from "./vk-data-input-editor.vue?vue&type=script&lang=js&"
import style0 from "./vk-data-input-editor.vue?vue&type=style&index=0&id=66a21f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a21f64",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/vk-data-input-editor/vk-data-input-editor.vue"
export default component.exports